import client from "./client";

export async function exportDevicesCSV(tenantId: string, params?: Record<string, string>) {
  const response = await client.get(`/tenants/${tenantId}/reports/devices/export`, {
    params,
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.download = "devices.csv";
  link.click();
  window.URL.revokeObjectURL(url);
}

export async function exportComplianceCSV(tenantId: string) {
  const response = await client.get(`/tenants/${tenantId}/reports/compliance/export`, {
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.download = "compliance.csv";
  link.click();
  window.URL.revokeObjectURL(url);
}
